import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27cefdd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex align-items-center" }
const _hoisted_2 = { class: "common-text mr-4" }
const _hoisted_3 = { class: "common-svg" }
const _hoisted_4 = {
  class: "common-i",
  style: {"z-index":"996"}
}
const _hoisted_5 = ["src"]

import { ref } from 'vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'XTitleIconLabel',
  props: {
    cursorProp: String,
    labelProp: String
},
  emits: ['iconClick'],
  setup(__props, { emit }) {

const props = __props



const cursor = ref(props.cursorProp);
const label = ref(props.labelProp);



const onClick = (event: any) => {
    emit('iconClick', event);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps({
    class: "flex align-items-center justify-content-between",
    style: {"height":"40px","margin-top":"18px","margin-left":"30px","margin-right":"30px"}
  }, _ctx.$attrs), [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(label.value), 1),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "svg")
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("img", {
        style: _normalizeStyle([{"width":"100%","height":"100%"}, cursor.value]),
        src: 'images/dashboard/right.png',
        onClick: onClick
      }, null, 12, _hoisted_5)
    ])
  ], 16))
}
}

})